import { HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable, take } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiHttpService } from '../../api-http.service';
import { CustomHttpResponse, Entity, HydraCollectionResponse, SearchHit, SearchHitType } from '../../../models';

export interface SearchOptions {
  /** Only these types; without them the API searches every type the user may search. */
  types?: SearchHitType[];
  itemsPerPage?: number;
}

/** The "search everything" box: documents, suppliers and articles in one ranked list. */
@Injectable({
  providedIn: 'root',
})
export class SearchService {
  #apiService = inject(ApiHttpService<SearchHit>);

  search(query: string, options: SearchOptions = {}): Observable<HydraCollectionResponse<SearchHit>> {
    let params = new HttpParams().set('q', query);
    for (const type of options.types ?? []) {
      params = params.append('type[]', type);
    }
    if (options.itemsPerPage) {
      params = params.set('itemsPerPage', options.itemsPerPage);
    }
    return this.#apiService.getMany(`/search?${params.toString()}`).pipe(
      take(1),
      map((result: CustomHttpResponse<HydraCollectionResponse<SearchHit>>) => result.body),
    );
  }

  /** The types the current user can search, in display order. */
  getTypes(): Observable<SearchHitType[]> {
    return this.#apiService.getById('/search_types').pipe(
      take(1),
      map((result) => (result as unknown as CustomHttpResponse<Entity & { types: SearchHitType[] }>).body.types),
    );
  }
}
